import { PROVIDER_CONFIGS } from '@config/providers/provider.config';
import { AIProviderBase, ProviderKey, ProviderCapabilities, MessageInterface, RequestConfig, FormattedRequest, ProviderResponse } from '@type/provider';

export class DeepInfraProvider implements AIProviderBase {
  id: ProviderKey;
  name: string;
  endpoints: string[];
  models: string[];
  capabilities: ProviderCapabilities;

  constructor() {
    const config = PROVIDER_CONFIGS.deepinfra;
    
    this.id = 'deepinfra';
    this.name = config.name;
    this.endpoints = config.endpoints;
    this.models = config.models.map(m => m.id);
    this.capabilities = {
      supportsThinking: config.capabilities.supportsThinking,
      maxCompletionTokens: config.models[0]?.maxCompletionTokens ?? 4096,
      defaultModel: config.defaultModel
    };
  }

  formatRequest(messages: MessageInterface[], config: RequestConfig): FormattedRequest {
    const filteredMessages = messages
      .filter(m => m.content.trim() !== '')
      .map(m => ({ role: m.role, content: m.content }));
    
    return {
      model: config.model,
      max_tokens: config.max_tokens,
      temperature: config.temperature,
      top_p: config.top_p,
      presence_penalty: config.presence_penalty,
      frequency_penalty: config.frequency_penalty,
      stream: config.stream ?? false,
      messages: filteredMessages
    };
  }

  parseResponse(response: unknown): string {
    const parsed = response as Partial<ProviderResponse> & { content?: string };

    if (!parsed) return '';
    if (parsed.content) return parsed.content;
    if (parsed.choices?.[0]?.message) {
      return parsed.choices[0].message.content;
    }
    throw new Error('Invalid response format from DeepInfra');
  }

  parseStreamingResponse(response: unknown): string {
    const parsed = response as Partial<ProviderResponse>;

    if (!parsed) return '';
    if (parsed.choices?.[0]?.delta) {
      return parsed.choices[0].delta.content || '';
    }
    return '';
  }
}